import { render, staticRenderFns } from "./ShoppingCartList.vue?vue&type=template&id=5b1186fe&scoped=true"
import script from "./ShoppingCartList.vue?vue&type=script&lang=js"
export * from "./ShoppingCartList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1186fe",
  null
  
)

export default component.exports